import * as yup from "yup";
import dayjs from "dayjs";
import { birthdayMask } from "uiConstants";
import { isValidDate } from "utils/dates";

import { errorsMessage } from "./errorMessages";

export const validation = {
  stringRequired: yup
    .string()
    .transform((value, originalValue) =>
      originalValue === null ? undefined : value,
    )
    .required(errorsMessage.required),
  stringNotRequired: yup
    .string()
    .required(errorsMessage.required)
    .notRequired(),

  emailRequired: yup
    .string()
    .email(errorsMessage.email)
    .required(errorsMessage.required),
  emailNotRequired: yup.string().email(errorsMessage.email).nullable(),
  dateRequired: yup
    .string()
    .transform((value, originalValue) =>
      originalValue === null ? undefined : value,
    )
    .required(errorsMessage.required)
    .test("valid-date", errorsMessage.invalid_date, (value) => {
      if (value === birthdayMask) return true;
      return isValidDate(value);
    }),
  dateRequiredNoPast: yup
    .string()
    .transform((value, originalValue) =>
      originalValue === null ? undefined : value,
    )
    .required(errorsMessage.required)
    .test("valid-date", errorsMessage.invalid_date, (value) => {
      if (value === birthdayMask) return true;
      return isValidDate(value);
    })
    .test("no-past", errorsMessage.no_past_date, (value) => {
      const date = dayjs(value).startOf("day");
      const now = dayjs().startOf("day");
      return date.isSame(now, "day") || date.isAfter(now, "day");
    }),
  ssn: yup
    .string()
    .required(errorsMessage.required)
    .matches(/^[0-9-]+$/, errorsMessage.invalid_format)
    .max(11)
    .notRequired(),
  dateNotRequired: yup
    .string()
    .transform((value, originalValue) =>
      originalValue === null ? undefined : value,
    )
    .test("valid-date", errorsMessage.invalid_date, (value) => {
      if (!value || value === birthdayMask) return true;
      return isValidDate(value);
    }),
  numberRequired: yup.number().required(errorsMessage.required),
  numberNotRequired: yup.number().nullable(),
  booleanNotRequired: yup.boolean().nullable(),
  booleanRequired: yup.boolean().required(errorsMessage.required),
  passwordValidation: yup
    .string()
    .required(errorsMessage.required)
    .min(8, errorsMessage.min_8_characters)
    .matches(/[a-z]/, errorsMessage.lowercase_required)
    .matches(/[A-Z]/, errorsMessage.uppercase_required)
    .matches(/\d/, errorsMessage.number_required)
    .matches(
      /[@$!%*?&#^()\-_=+[\]{}|\\:;'",.<>/~`]/,
      errorsMessage.special_character,
    ),
};
